import { FC } from "react";
import MuiPagination, {
  PaginationProps as MuiPaginationProps,
} from "@mui/material/Pagination";
import MuiPaginationItem from "@mui/material/PaginationItem";
import { ChevronIcon } from "@/components/Icon";
import Button from "@/components/Button";
import Typography from "@/components/Typography";
import styles from "./Pagination.module.scss";

type Props = MuiPaginationProps;

const Pagination: FC<Props> = ({ ...props }) => {
  return (
    <MuiPagination
      {...props}
      renderItem={(item) => (
        <MuiPaginationItem
          components={{
            previous: () => (
              <div className={styles.backButton}>
                <ChevronIcon dir="left" className={styles.backIcon} />
                <Typography variant="button" className={styles.text}>
                  Back
                </Typography>
              </div>
            ),
            next: () => (
              <div className={styles.nextButton}>
                <Typography variant="button" className={styles.text}>
                  Next
                </Typography>
                <ChevronIcon className={styles.nextIcon} />
              </div>
            ),
          }}
          {...item}
        />
      )}
    />
  );
};

export default Pagination;
